"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBSTITUTES = void 0;
exports.SUBSTITUTES = {
    alias: 'SUBSTITUIRS',
    description: 'Substitui valores na {string_original} usando N pares de parâmetros no {pares_a_substituir} como chave, valor (chave a buscar, valor a substituir)',
    arg_names: ['string_original', 'pares_a_substituir'],
    args_description: [
        'string a ser buscada e substituída',
        'parâmetro repetível usado em pares (de chave valor) para buscar e substituir (N pares podem ser enviados). Se a contagem de parâmetros repetíveis for ímpar, a última chave recebida não será substituida',
    ],
};
